module.exports = __webpack_public_path__ + "static/media/godishen_finansov_otchet_2016.ac26a738.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2017/godishen_finansov_otchet_2016.pdf
// module id = 159
// module chunks = 0